/** Typography for the Signals feature only. */
export const SIGNALS_FONT_FAMILY =
  'ibm-plex-sans, "Helvetica Neue", Helvetica, Arial, sans-serif';
